import * as React from "react";
import { cn } from "@/lib/utils";

// Main Card container
export const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("bg-background-secondary border border-border-primary rounded-xl p-5", className)} {...props} />
));

// Card Header (usually contains title and description)
export const CardHeader = React.forwardRef(({ className, ...props }, ref) => <div ref={ref} className={cn("flex flex-col items-center p-6", className)} {...props} />);

// Card Title (main heading)
export const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("text-2xl font-semibold leading-none tracking-tight", className)} {...props} />
));

// Card Description (subtitle or extra info)
export const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("text-sm text-muted-foreground", className)} {...props} />
));

// Card Content (main content area)
export const CardContent = React.forwardRef(({ className, ...props }, ref) => <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />);

// Card Footer (actions like buttons or links)
export const CardFooter = React.forwardRef(({ className, ...props }, ref) => <div ref={ref} className={cn("flex items-center p-6 pt-0", className)} {...props} />);
